import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { ImageUploadConfig, ImageUploadResult, ImageUploadComponent } from '../../components/image-upload/image-upload.component';

interface ImageUploadProps extends FormlyFieldProps {
  uploadConfig: ImageUploadConfig;
  onUploadComplete?: (field: any, result: ImageUploadResult) => void;
  onUploadError?: (field: any, error: string) => void;
}

@Component({
  standalone: true,
  selector: 'formly-field-image-upload',
  imports: [ImageUploadComponent, ReactiveFormsModule],
  template: `
    <app-image-upload
      [config]="props.uploadConfig"
      [formControl]="formControl"
      (uploadComplete)="onUploadComplete($event)"
      (uploadError)="onUploadError($event)">
    </app-image-upload>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldImageUpload extends FieldType<FieldTypeConfig<ImageUploadProps>> {

  onUploadComplete(result: ImageUploadResult): void {
    // Call custom handler if provided
    if (this.props.onUploadComplete) {
      this.props.onUploadComplete(this.field, result);
    }
  }

  onUploadError(error: string): void {
    // Call custom handler if provided
    if (this.props.onUploadError) {
      this.props.onUploadError(this.field, error);
    }
  }
}
